import { render, staticRenderFns } from "./superAceX.vue?vue&type=template&id=aaf80ac2&scoped=true"
import script from "./superAceX.vue?vue&type=script&lang=js"
export * from "./superAceX.vue?vue&type=script&lang=js"
import style0 from "./superAceX.vue?vue&type=style&index=0&id=aaf80ac2&prod&scoped=true&lang=css"
import style1 from "./superAceX.vue?vue&type=style&index=1&id=aaf80ac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf80ac2",
  null
  
)

export default component.exports